import UserPermission from "../UserPermission";
import api from "../../services/api";

const userPermission = UserPermission();

export const getAllStatuses = async () => {
    try {
        const response = await api.get(`/complaint-statuses`);
        return response.data;
    } catch (err) {
        console.error('Erro ao buscar status', err);
        return [];
    }
};

export const getEvaluations = async () => {
    try {
        const { data: evaluations } = await api.get(`${userPermission}/evaluations`);
        return evaluations;
    } catch (err) {
        console.log('Erro ao buscar avaliações', err)
    }
}

export const getAreasUser = async () => {
    try {
        const { data: profile } = await api.get(`${userPermission}/areas`);
        return profile.areas;
    } catch (err) {
        console.error('Erro ao buscar áreas do usuário', err);
        return [];
    }
};

export const getGroups = async () => {
    try {
        const { data: groups } = await api.get(`/groups`);
        return groups;
    } catch (err) {
        console.error('Erro ao buscar grupos', err);
        return [];
    }
};

export const getTarget = async () => {
    try {
        const { data: target } = await api.get(`/complaint-categories?`);
        return [{ target: 'Todos' }, ...target];
    } catch (err) {
        console.error('Erro ao tipos de serviço', err);
        return [];
    }
};

export const getBairros = async () => {
    try {
        const data = { order: 'name ASC' };
        const { data: neighborhoods } = await api.get(`${userPermission}/neighborhoods?filter=${JSON.stringify(data)}`);
        return [{ name: 'Todos' }, ...neighborhoods];
    } catch (err) {
        console.error('Erro ao buscar bairros', err);
        return [{ name: 'Todos' }];
    }
};

export const getExecutorsUsers = async () => {
    try {
        const filter = { where: { role: 'Executor' }, order: 'name ASC' };
        const { data: executors } = await api.get(`${userPermission}/users?filter=${JSON.stringify(filter)}`);
        return [{ name: 'Todos' }, ...executors];
    } catch (err) {
        console.error('Erro ao buscar executores', err);
        return [{ name: 'Todos' }];
    }
};

export const getControladoresUsers = async () => {
    try {
        const filter = { where: { role: 'Controlador' }, order: 'name ASC' };
        const { data: controladores } = await api.get(`${userPermission}/users?filter=${JSON.stringify(filter)}`);
        return [{ name: 'Todos' }, ...controladores];
    } catch (err) {
        console.error('Erro ao buscar controladores', err);
        return [{ name: 'Todos' }];
    }
};

export const getAreas = async () => {
    try {
        const fields = {
            id: true,
            name: true,
            groupId: true,
        };

        const include = [{
            relation: 'group',
            scope: {
                fields: {
                    id: true,
                    nameSecretary: true
                }
            }
        }];

        const data = { order: ["groupId", "name"], include, fields };
        const { data: areas } = await api.get(`${userPermission}/areas?filter=${JSON.stringify(data)}`);
        return areas;
    } catch (err) {
        console.error('Erro ao buscar áreas', err);
        return [];
    }
};
